import { TextField, styled } from '@mui/material';

const InputDate = styled(TextField)`
  min-width: 200px;
`;

export default InputDate;
